import { createApp } from 'vue';

import BasePage from './components/base/BasePage.vue';
import CommandMap from './components/comandoapp/CommandMap.vue';
import HomePage from './components/comandoapp/HomePage.vue';
import LandingPolz from './components/polz/LandingPolz.vue';
import LandingRefugios from './components/refugios/LandingRefugios.vue';
import LoginForm from './components/comandoapp/LoginForm.vue';
import TableroNegocio from './components/comandoapp/TableroNegocio.vue';
import VoiceRecorder from './components/comandoapp/VoiceRecorder.vue';

// El reset de Vuetify va antes que los estilos propios: su `[type=button] { color:
// inherit }` pesa lo mismo que una clase y, cargado después, la pisa.
import 'vuetify/styles';
import './index.css';
import './components/comandoapp/comando.css';
import './components/comandoapp/negocio.css';

// Vuetify queda montado para las vistas que vengan; el mapa usa CSS propio
// para no depender de su grilla.
import { createVuetify } from 'vuetify';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

const vuetify = createVuetify({
  icons: { defaultSet: 'mdi', aliases, sets: { mdi } },
  theme: {
    defaultTheme: 'comando',
    themes: {
      comando: {
        dark: true,
        colors: { primary: '#40C4FF', secondary: '#1E88E5' },
      },
    },
  },
  components,
  directives,
});

// El template lo entrega Django en base.html: se monta sobre #app y los
// componentes van registrados globalmente.
const app = createApp({
  components: { BasePage, CommandMap, HomePage, LandingPolz, LandingRefugios, LoginForm, TableroNegocio },
});

app.component('BasePage', BasePage);
app.component('CommandMap', CommandMap);
app.component('HomePage', HomePage);
app.component('LandingPolz', LandingPolz);
app.component('LandingRefugios', LandingRefugios);
app.component('LoginForm', LoginForm);
app.component('TableroNegocio', TableroNegocio);
app.component('VoiceRecorder', VoiceRecorder);

app.use(vuetify);
app.mount('#app');
